import * as client_hooks from '../../../../src/hooks.client.ts';
import * as universal_hooks from '../../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26')
];

export const server_loads = [0,4,5];

export const dictionary = {
		"/(marketing)": [~23,[7]],
		"/(marketing)/about": [24,[7]],
		"/(marketing)/blog": [~25,[7]],
		"/(marketing)/blog/[slug]": [~26,[7]],
		"/(app)/chain/[slug]": [~8,[2],[3]],
		"/(app)/chart": [~9,[2],[3]],
		"/(app)/chart/time": [~10,[2],[3]],
		"/(app)/compare": [11,[2,4],[3]],
		"/(app)/compare/market-cap": [13,[2,5],[3]],
		"/(app)/compare/market-cap/[slug]": [14,[2,5],[3]],
		"/(app)/compare/[slug]": [12,[2,4],[3]],
		"/(app)/dashboard": [~15,[2,6],[3]],
		"/(app)/dashboard/agent-activity": [~16,[2,6],[3]],
		"/(app)/dashboard/agents": [~17,[2,6],[3]],
		"/(app)/dashboard/crypto-card-activity": [~18,[2,6],[3]],
		"/(app)/dashboard/crypto-cards": [~19,[2,6],[3]],
		"/(app)/dashboard/decentralization": [~20,[2,6],[3]],
		"/(app)/dashboard/developer-activity": [~21,[2,6],[3]],
		"/(app)/dashboard/financials": [~22,[2,6],[3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);